import React from "react";
import { useTranslation } from 'react-i18next';

import Paper from "@/components/paper/Paper";
import Cards from "@/components/multipleCards/Cards";

// const executeSetAnchorsSectionData = () => {
//   // TODO
//   const setAnchorsSectionData = window["___SET_ANCHORS_SECTION_DATA___"];

//   if (setAnchorsSectionData) {
//     setAnchorsSectionData();
//   }
// };

const InTheAreasOf = (): JSX.Element => {
  const { t } = useTranslation();
  const cardsData = t("companyProfile.inTheAreasOf.creditReportsEntries", { returnObjects: true });
  // if (typeof seeAllLinkPath !== "string") {
  //   throw new Error("typeof props.seeAllLinkPath is not string");
  // }
  // const hideCreditReports = isNotUndefined(country) && isNotUndefined(locale) && country !== canadaIsoCode && country !== unitedStatesIsoCode;
  const hideCreditReports = false;

  return (
    <>
      {hideCreditReports ? (
        <></>
      ) : (
        <>
          <Paper
            title={t('companyProfile.inTheAreasOf.headingText')}
            additionalContainerClass="business-directory-credit-reports credit-reports-parent"
          >
          <Cards 
            businessCreditReportProductCaUrl = {t('companyProfile.inTheAreasOf.businessCreditReportProductCaUrl')}
            creditReportsEntries = {cardsData}
            suppress_credit_report_product_link_with_text = {t('companyProfile.inTheAreasOf.suppress_credit_report_product_link_with_text')} />
          </Paper> </>
      )}
    </>
  );
};

export default InTheAreasOf;

